import React from 'react';
import { useIdentityChallengeContext } from 'Context/IdentityChallengeContext';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { FDDialog } from '@facet-wealth/design';
import getStep from './Steps';


const IDENTITY_CHALLENGE_DIALOG_ID = 'identity-challenge-dialog';


const IdentityChallengeDialog = () => {
  const {
    challengeFlowCollection,
    handleConfirmClose,
    setChallengeFlowCollection,
  } = useIdentityChallengeContext();

  const {
    Layout,
    metaOverrideSet,
  } = getStep(challengeFlowCollection);

  const { displayErrorMessage } = useSnackbarContext();

  React.useEffect(() => {
    const dialogEls = Array.from(window.document.querySelectorAll('[data-modal-type="dialog"]'));

    const otherDialogEls = dialogEls.filter((el) => {
      return el.id !== IDENTITY_CHALLENGE_DIALOG_ID;
    });
    const displays = otherDialogEls.map((el) => {
      return el.style.display;
    });

    // set display none
    otherDialogEls.forEach((el) => {
      // eslint-disable-next-line no-param-reassign
      el.style.display = 'none';
    });

    return () => {
      for (let i = 0; i < otherDialogEls.length; i++) {
        otherDialogEls[i].style.display = displays[i];
      }
    };
  }, []);

  return (
    <FDDialog
      id={IDENTITY_CHALLENGE_DIALOG_ID}
      onClose={handleConfirmClose}
      open
    >
      <MetaCollectionFormInline
        collection={challengeFlowCollection}
        metaOverrideSet={metaOverrideSet}
        FormProps={{
          noIndividualSubmitButtons: true,
          layout: Layout,
          onSubmit: (coll) => {
            return setChallengeFlowCollection(coll);
          },
          LayoutProps: {
            hideErrorList: true,
          },
          onFailure: (err) => {
            if (err.status !== 400 || (err.errors.length === 1 && err.errors[0].source == null)) {
              displayErrorMessage(err, err.errors);
            }
          },
        }}
        padding={'none'}
        margin={'none'}
      />
    </FDDialog>
  );
};

IdentityChallengeDialog.defaultProps = {
};

IdentityChallengeDialog.propTypes = {
};

export default IdentityChallengeDialog;
